// extracted by mini-css-extract-plugin
export default {"form":"ClientesCnpjIndex_form__AMY6b","areaBtn":"ClientesCnpjIndex_areaBtn__HC4Gs","btn":"ClientesCnpjIndex_btn__j55X1","td":"ClientesCnpjIndex_td__1hOUy"};